// iter45ap 4b-ii — pickPackageIcon
// Discriminator uses PACKAGES `.id` (canonical), NOT the legacy `.kind`
// field. Historically PurchaseModal branched off `pkg.kind === "single"`
// which quietly broke when the PACKAGES table added `.id` as its
// primary discriminator; the modal kept rendering the wrong icon and
// the wrong toast for a while. This helper is the single source of
// truth so every consumer (icon + toast + snapshot gate) agrees.
//
// Returns a stable STRING name, not a component — so tests don't
// have to import lucide-react. The consumer (PurchaseModal.jsx) maps
// name → component at the render site.

export function pickPackageIcon(pkg) {
  const id = (pkg && pkg.id) || "";
  if (id === "single_report") return "FileText";
  if (id.startsWith("credit_bundle_") || id.startsWith("custom_bundle_")) {
    const credits = (pkg && Number(pkg.credits)) || 0;
    return credits >= 10 ? "Sparkles" : "Star";
  }
  // Defensive default: any unknown package renders the neutral icon.
  return "FileText";
}
